module.exports = __webpack_public_path__ + "img/pressureSensor.f84cf967.svg";